import { createApiRequest } from "@/lib/api/createApiService";
import { ORGANIZATION_ENDPOINTS } from "./organization.endpoints";

export const organizationService = {
  fetchHierarchy: async (options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.LIST,
      method: "GET",
      ...options,
    });
  },

  fetchLookups: async (options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.LOOKUPS,
      method: "GET",
      ...options,
    });
  },

  createUnit: async (payload, options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.CREATE,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateUnit: async (unitId, payload, options = {}) => {
    if (!unitId) throw new Error("unitId is required");
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.UPDATE(unitId),
      method: "PATCH",
      body: payload,
      ...options,
    });
  },

  deleteUnit: async (unitId, options = {}) => {
    if (!unitId) throw new Error("unitId is required");
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.DELETE(unitId),
      method: "DELETE",
      ...options,
    });
  },
};
